function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
  fill: "#5C0BD9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26 14L14 18.8L15.3 26.4L19.2 26.9C19.7 27 20.1 27.2 20.4 27.6C20.7 28 20.9 28.5 20.9 29L20.4 49.8H43.5L43 29C43 28.5 43.2 28 43.5 27.6C43.8 27.2 44.3 27 44.7 26.9L48.6 26.4L49.9 18.8L38 14C37.7 13.9 26.2 13.9 26 14Z",
  stroke: "white",
  strokeWidth: 1.7439,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38 14.8999C38 18.1999 35.3 20.8999 32 20.8999C28.7 20.8999 26 18.1999 26 14.8999",
  stroke: "white",
  strokeWidth: 1.7439,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgTorsoIcon = function SvgTorsoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTorsoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/torso-icon.a07a524d.svg";
export { ForwardRef as ReactComponent };